export const postback = {
  state: {
    init: {
      description:
        'Позволяет после совершения любого действия в АТС отправить на указанный URL сообщение с необходимыми параметрами.'
    }
  },
  url: 'URL',
  key: 'Ключ',
  value: 'Значение',
  area: 'Начните ввод...'
};
